import { Actions, PrimaryAction, SecondaryAction } from './Actions'
import { Message } from './Message'
import { Content } from './Content'
import { Root } from './Root'
import { CloseButton, Header, Icon, Title } from './Header'
import { Checkbox } from './Checkbox'

export const PersistentToast = {
  Root,
  Header,
  Message,
  Content,
  Actions,
  PrimaryAction,
  SecondaryAction,
  Icon,
  CloseButton,
  Title,
  Checkbox,
}
